/**
 * DemoEndedPage — Iter-94.
 *
 * Landing surface a PM lands on when their 24-hour demo sandbox session
 * expires. Deliberately clean: single message + a strong CTA to contact
 * the NECS Customer Service team so the sales handoff feels intentional.
 */
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Clock, Sparkles } from 'lucide-react';

export default function DemoEndedPage() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#0a0a0a' }}
      data-testid="demo-ended-page"
    >
      <Card
        className="max-w-lg w-full p-10 text-center border-zinc-800"
        style={{ backgroundColor: '#141414' }}
      >
        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-full flex items-center justify-center border" style={{ borderColor: '#C9A962' }}>
            <Clock className="h-8 w-8" style={{ color: '#C9A962' }} />
          </div>
        </div>
        <h1
          className="text-3xl sm:text-4xl font-black text-white mb-3"
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          data-testid="demo-ended-title"
        >
          YOUR DEMO HAS ENDED
        </h1>
        <p className="text-sm text-zinc-300 mb-2" data-testid="demo-ended-subtitle">
          Ready to get started?
        </p>
        <p className="text-[13px] text-zinc-400 mb-8">
          Your 24-hour sandbox has closed and no real account was created.
          A Customer Service specialist can activate a live property manager
          account in under one business day.
        </p>

        <div className="flex flex-col gap-3">
          <Link to="/contact" data-testid="demo-ended-contact-link">
            <Button
              className="w-full font-black text-lg py-6"
              style={{
                backgroundColor: '#FFD60A',
                color: '#1a1a1a',
                fontFamily: 'Barlow Condensed, sans-serif',
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
              }}
              data-testid="demo-ended-contact-btn"
            >
              <Sparkles className="h-4 w-4 mr-2" />
              Contact NECS
            </Button>
          </Link>
          <Link
            to="/live-demo"
            className="text-[12px] text-zinc-500 hover:text-zinc-300 transition"
            data-testid="demo-ended-restart-link"
          >
            or start a fresh 24-hour demo
          </Link>
        </div>
      </Card>
    </div>
  );
}
